import script from "./ShiftList.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftList.vue?vue&type=script&setup=true&lang=js"

import "./ShiftList.vue?vue&type=style&index=0&id=2d04d48e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d04d48e"]])

export default __exports__